module.exports = __webpack_public_path__ + "static/media/Sable-Content.a3daca9c.jpeg";